export const AllowMultipleDownloadsModal = () => {
	return <div>Please allow the browser to download multiple files.</div>;
};
